import React from 'react'
import PropTypes from 'prop-types'

function Right({ children, ratio = 9 }) {
  return (
    <div className={`right col-lg-${ratio}`} id='split-view-right'>{children}</div>
  )
}

Right.propTypes = {
  children: PropTypes.element.isRequired,
  ratio: PropTypes.number,
}

export default Right
